import callAPiBase from './base';

const bugReportsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/bugReportList',
      method: 'GET',
      useToken: true,
      title: 'Bug Report - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/bugReportCreate',
      method: 'POST',
      useToken: true,
      title: 'Bug Report - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/bugReportUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Bug Report - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/bugReportDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Bug Report - Delete',
      params,
    }),
};

export { bugReportsApi };
export default bugReportsApi;
